import ApiUtils from "../ApiUtils";

export default class ApiCompanyService {

    async addNewCompany(data) {
        return await ApiUtils.callApi('company/add','post',data);
    }

    async getACompanyDetailsForEdit(companyId){
        return await ApiUtils.callApi(`company/details/${companyId}`,'get');
    }

    async updateACompanyDetails(data){
        return await ApiUtils.callApi(`company/update`,'post', data);
    }

    async getACompanyDetailsByLocation(data){
        return await ApiUtils.callApi(`company/all/info`,'post', data);
    }

    // Company Contact

    async addCompanyContact(data){
        return await ApiUtils.callApi(`company/contact/add`,'post', data);
    }

    async getAllCompanyContacts(data){
        return await ApiUtils.callApi(`company/contact/find`,'post', data);
    }

    async deleteCompanyContact(contactId){
        return await ApiUtils.callApi(`company/contact/delete?id=${contactId}`,'delete');
    }

    async getACompanyContactForEdit(contactId){
        return await ApiUtils.callApi(`company/contact/get/${contactId}`,'get');
    }

    async updateCompanyContact(data){
        return await ApiUtils.callApi(`company/contact/update`,'post', data);
    }

    async deleteCompanyContactLocation(data){
        let url = 'company/contact/location?';
        data.forEach((id, index) => {
            url += `contact_loc_id[${index}]=${id}`
        });
        return await ApiUtils.callApi(url,'delete');
    }

    async addCompanyContactLocation(data){
        return await ApiUtils.callApi('company/contact/location','post',data);
    }

    async updateContactLocationPrimary(contactLocationId,contactId){
        return await ApiUtils.callApi(`company/contact/location/set-primary/${contactLocationId}/${contactId}`,'patch');
    }

    // notification settings

    async getCompanyContactNotificationSettings(companyId,locationId){
        return await ApiUtils.callApi(`company/contact/notification/settings/${companyId}/${locationId}`,'get');
    }

    async getACompanyContactNotificationSettingsForEdit(contactId,locationId){
        return await ApiUtils.callApi(`company/contact/notification/settings/edit/${contactId}/${locationId}`,'get');
    }

    async updateACompanyContactNotificationSettings(data){
        return await ApiUtils.callApi(`company/contact/notification/settings/edit`,'post',data);
    }

    // Company Locations

    async addCompanyLocation(data){
        return await ApiUtils.callApi(`company/location/add`,'post',data);
    }

    async findCompanyLocation(data){
        return await ApiUtils.callApi(`company/location/find`,'post',data);
    }

    async deleteCompanyLocation(locationId){
        return await ApiUtils.callApi(`company/location/delete?location_id=${locationId}`,'delete');
    }

    async getACompanyLocationData(locationId){
        return await ApiUtils.callApi(`company/location/${locationId}`,'get');
    }

    async updateCompanyLocation(data){
        return await ApiUtils.callApi(`company/location/update`,'post',data);
    }
}
